import React from 'react';
import PropTypes from 'prop-types';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const FROSTED_GLASS_ANGLE = '-7.25deg';

const useStyles = buildUseStyles('FrostedGlassEffect', (theme) => ({
  root: {
    position: 'relative',
    overflow: 'hidden', // The frosted glass needs is going to be made longer than necessary - avoid it being able to go out of bounds
  },
  frostedGlass: {
    height: '100%',
    width: '100%',
    position: 'absolute',
    background: theme.palette.facet.gentlyFrosted,
    transform: `rotate(${FROSTED_GLASS_ANGLE}) scale(1.18)`,
    pointerEvents: 'none',
  },
}));

export function FrostedGlassEffect({ children }) {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div className={classes.frostedGlass} />
      {children}
    </div>
  );
}

FrostedGlassEffect.propTypes = {
  children: PropTypes.node.isRequired,
};
